export default __webpack_public_path__ + "src/assets/magnite_logo.png";